import type { Theme } from '../../types/theme';

export const hashicorpTheme: Theme = {
  id: 'hashicorp',
  name: 'HashiCorp',
  description: 'Enterprise-clean black and white design for infrastructure automation',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/hashicorp/DESIGN.md',
  visualKeywords: ['clean', 'enterprise', 'black white', 'minimal', 'infrastructure'],
  colors: {
    background: '#ffffff',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#000000',
    textSecondary: '#666666',
    textMuted: '#666666',
    border: '#e0e0e0',
    borderSubtle: '#d6d6d6',
    primary: '#60dea9',
    primaryHover: '#6fedb8',
    primaryActive: '#42c08b',
    accent: '#60dea9',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'professional',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
